import { render } from "./VerificationStatus.vue?vue&type=template&id=085abf92&scoped=true&ts=true"
import script from "./VerificationStatus.vue?vue&type=script&lang=ts"
export * from "./VerificationStatus.vue?vue&type=script&lang=ts"

import "./VerificationStatus.vue?vue&type=style&index=0&id=085abf92&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085abf92"],['__file',"src/components/kyc/VerificationStatus.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "085abf92"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('085abf92', __exports__)) {
    api.reload('085abf92', __exports__)
  }
  
  module.hot.accept("./VerificationStatus.vue?vue&type=template&id=085abf92&scoped=true&ts=true", () => {
    api.rerender('085abf92', render)
  })

}


export default __exports__